export default __webpack_public_path__ + "static/media/be_a_respondent1.1b654c38.png";